export default "__VITE_ASSET__1RzMZXhD__"